import { render, staticRenderFns } from "./check-result.vue?vue&type=template&id=ff120b08&scoped=true"
import script from "./check-result.vue?vue&type=script&lang=js"
export * from "./check-result.vue?vue&type=script&lang=js"
import style0 from "./check-result.vue?vue&type=style&index=0&id=ff120b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff120b08",
  null
  
)

export default component.exports